import AdminHeader from '../components/common/AdminHeader';
import PricingManagementComponent from '../components/pricing/PricingManagement';
import PermissionGuard from '../components/common/PermissionGuard';
import ReferralPage from '@/components/dashboard/parent/ReferAFriend';
import ParentHeader from '@/components/common/ParentHeader';

export default function ReferAFriendPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <ParentHeader />
      <main className="max-w-9xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {/* <PermissionGuard screen="referral"> */}
          <ReferralPage />
        {/* </PermissionGuard> */}
      </main>
    </div>
  );
}
